import { useMemo } from 'react'
import { BLOCKED_RETURN_REASON } from 'shipping-and-returns/constants/blockedReturnReason'
import { RETURN_TYPES } from 'shipping-and-returns/constants/returnTypes'
import type { UnavailableReturnMethod } from 'shipping-and-returns/types/ReturnsInfo.types'

export const useBlocksByReturnsLimit = (
	unavailableReturnMethods: UnavailableReturnMethod[] = []
) => {
	const {
		isHomePickUpBlockedByReturnsLimit,
		isDropPointBlockedByReturnsLimit,
	} = useMemo(() => {
		const blockedMethod = unavailableReturnMethods?.find(
			(method) => method?.reason === BLOCKED_RETURN_REASON.RETURNS_LIMIT
		)

		return {
			isHomePickUpBlockedByReturnsLimit:
				blockedMethod?.returnMethodId === RETURN_TYPES.HOME_PICK_UP,
			isDropPointBlockedByReturnsLimit:
				blockedMethod?.returnMethodId === RETURN_TYPES.DROPPOINT,
		}
	}, [unavailableReturnMethods])

	const { homePickUpBlockedMessage, dropPointBlockedMessage } = useMemo(() => {
		if (
			!isHomePickUpBlockedByReturnsLimit &&
			!isDropPointBlockedByReturnsLimit
		) {
			return { homePickUpBlockedMessage: '', dropPointBlockedMessage: '' }
		}

		return {
			homePickUpBlockedMessage: isHomePickUpBlockedByReturnsLimit
				? 'myReturns.returnOptions.blocked.subtitle'
				: 'myReturns.returnOptions.unavailable.subtitle',
			dropPointBlockedMessage: isDropPointBlockedByReturnsLimit
				? 'myReturns.returnOptions.blocked.subtitle'
				: 'myReturns.returnOptions.unavailable.subtitle',
		}
	}, [isHomePickUpBlockedByReturnsLimit, isDropPointBlockedByReturnsLimit])

	return {
		isOrderBlockedByReturnsLimit:
			isHomePickUpBlockedByReturnsLimit || isDropPointBlockedByReturnsLimit,
		isHomePickUpBlockedByReturnsLimit,
		isDropPointBlockedByReturnsLimit,
		homePickUpBlockedMessage,
		dropPointBlockedMessage,
	}
}
